import { FC, ReactNode } from 'react'

import style from '../style.m.less'

type PageContainerProps = {
    className?: any
    children: ReactNode
}

const PageContainer: FC<PageContainerProps> = ({ className, children }) => (
    <div className={className || style.container}>{children}</div>
)

export default PageContainer
